var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MINI = void 0;
exports.MINI = false;
//# sourceMappingURL=constants.js.map
export default exports;